// 交付产物「当前阶段」受控取值：server 与 website 共享的纯领域常量。
// 零 drizzle / IO 依赖。与渲染流水线的 biz_stage 概念解耦，仅描述交付产物自身阶段。

export const DELIVERABLE_STAGES = [
  'Demo',
  'A-Copy',
  'B-Copy',
  'Master',
  'Distribution',
] as const

export type DeliverableStage = (typeof DELIVERABLE_STAGES)[number]

// Master 是「配置态」阶段：仅在渲染配置页（profile / profile template）可见，用于配置母带渲染规格。
// review / deliverable / project 等阶段选择处一律用 REVIEW_STAGES（不含 Master）。
export const MASTER_STAGE = 'Master' satisfies DeliverableStage

export const REVIEW_STAGES = DELIVERABLE_STAGES.filter(stage => stage !== MASTER_STAGE)
export type ReviewStage = Exclude<DeliverableStage, typeof MASTER_STAGE>
